// this is an autogenerated file from DesignSystem/Report/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_Report($report_type: String!, $filters: jsonb!) {
  reports_run_stock_reports(report_type: $report_type, filters: $filters) {
    id
    status
    url
    created_at
  }
}

`